export default __webpack_public_path__ + "static/media/browsing-mental-model.4a4ddb75.png";